import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLayoutTypes} from 'src/openapi/admin/apis/UserContentDictionariesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLayoutTypes} from './services/dictionary-slice';

export const useLayoutTypes = () => {
    const apiDispatch = useAppDispatch();
    const layoutTypes = useSelector(selectLayoutTypes);

    const loadLayoutTypes = useCallback(() => {
        if (!layoutTypes.length) {
            apiDispatch(getLayoutTypes());
        }
    }, [layoutTypes.length, apiDispatch]);

    const getLayoutTypeByCode = useCallback((code: string) => {
        return layoutTypes?.find(e => e.code === code);
    }, [layoutTypes]);

    return {layoutTypes, loadLayoutTypes, getLayoutTypeByCode};
};
